// 404s and such
export class NetError
{
	public readonly message: string;
	public readonly code: number;

	// Optional, best-effort fields populated from a JSON error body (e.g. { ErrorCode, ErrorMessage }),
	// when the failing response provides one. Callers that need to surface a specific backend
	// message can check these without changing the default `.message` used everywhere else.
	public readonly errorCode?: string;
	public readonly apiMessage?: string;

	public constructor(
		message: string,
		code: number,
		errorCode?: string,
		apiMessage?: string,
	)
	{
		this.message = message;
		this.code = code;
		this.errorCode = errorCode;
		this.apiMessage = apiMessage;
	}
}